import React from 'react';

/**
 * WorkbenchFrame — full-screen embed for one of the static workbench
 * HTML surfaces (/public/wb-*.html). Used to route showcase-card clicks
 * to the right working surface:
 *
 *   "Build a website"     → /wb-website.html
 *   "Make a video"        → /wb-video.html
 *   "Generate an image"   → /wb-imagegen.html (or ImageGenView)
 *   "Shop for me"         → /wb-shopping.html
 *
 * The iframe takes the whole viewport (minus the hamburger / hero). A
 * floating "Back to home" button in the top-right corner pops the user
 * back to the ask surface. The drawer-open shift is honored so the panel
 * slides right when the hamburger menu is open.
 */
function WorkbenchFrame({ src, title }) {
  const onBack = () => {
    try {
      window.location.hash = '';
    } catch (_) {}
  };
  return (
    <div className="workbench-frame" role="region" aria-label={title || 'Workbench'}>
      <button
        type="button"
        className="workbench-frame__back"
        onClick={onBack}
        aria-label="Back to home"
        title="Back to home"
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 12H5" />
          <path d="M12 19l-7-7 7-7" />
        </svg>
        <span>Home</span>
      </button>
      <iframe
        src={src}
        title={title || 'Workbench'}
        className="workbench-frame__iframe"
        allow="clipboard-write; clipboard-read; camera; microphone; autoplay"
      />
    </div>
  );
}

export default React.memo(WorkbenchFrame);
